const ProtocolCmd = require("./ProtocolCmd");
const CMiddleServer = require("./MiddleServer");

CGateServer.prototype = Object.create(CMiddleServer.prototype);
CGateServer.prototype.constructor = CGateServer;
CGateServer.prototype.parent = CMiddleServer.prototype;

function CGateServer()
{
	let oGateServer = null;
	let onOpenTimeout = null;
	let mConnected = false;
	let mServerUri = null;
	let mWebsocket = null;
	let mReconnectDelay = 0;
	let mReconnectTimeout = null;
	let mProtocol = null; 

	CMiddleServer.call(this);

	function onOpen(e, websocket)
	{
		console.log(`CGateServer onopen at ${new Date()}`);
		// have to delay for a while for websocket gets ready
		if (onOpenTimeout) clearTimeout(onOpenTimeout);
		onOpenTimeout = setTimeout(function() {
			onOpenTimeout = null;
			mWebsocket = websocket;
			const obj = {
				deviceName: oGateServer.deviceName(),
				connectionId: oGateServer.connectionId(),
				gmClient: false
			};
			// send request to get deviceName & connectionId...
			oGateServer.invoke(ProtocolCmd.RequestConnectionInfo, JSON.stringify(obj));
			// reset delay
			mReconnectDelay = 0;
		}, 100);
	}

	function onClose(errMsg)
	{
		console.log(`CGateServer onclose at ${new Date()}`);
		if (mServerUri) {
			if (!mReconnectTimeout) {
				// delay
				mReconnectTimeout = setTimeout(function() {
					clearTimeout(mReconnectTimeout);
					mReconnectTimeout = null;
					if (mReconnectDelay < 30) mReconnectDelay++;
					// do reconnect
					oGateServer.reconnect(errMsg);
				}, mReconnectDelay * 1000);
			}
		}
		else {
			mConnected = false;
			oGateServer.onDisconnected(errMsg);
		}
	}

	const packets = {};
	function onMessage(e)
	{
		console.log(`CGateServer onmessage at ${new Date()}`);
		const objData = JSON.parse(e.data);
		if (objData.hasOwnProperty('id') &&
			objData.hasOwnProperty('total') &&
			objData.hasOwnProperty('index') &&
			objData.hasOwnProperty('content')) {

			const id = objData['id'];
			const total = objData['total'];
			const index = objData['index'];
			const content = objData['content'];
			if (total > 0 && index >= 0 && content) {
				if (packets.hasOwnProperty(id) == false) {
					const contents = [];
					for (let i = 0; i < total; i++) contents.push(null);
					packets[id] = contents;
				}
				const packetContents = packets[id];
				packetContents[index] = content;
				// check all arrived packets and return if not complete.
				let fullContent = '';
				for (let i = 0; i < total; i++) {
					if (!packetContents[i]) return;
					fullContent += packetContents[i];
				}
				// process message
				onMessage({
					data: fullContent
				});
				// remove packet
				delete packets[id]
			}
		}
		else {
			const cmd = objData.cmd;
			const data = objData.data;
				
			if (cmd === ProtocolCmd.ConnectionInfo) {
				const info = JSON.parse(data);
				const deviceName = info["deviceName"] ? info["deviceName"].toString() : null;
				const connectionId = info["connectionId"] ? info["connectionId"].toString() : null;
				const result = oGateServer.onConnectionInfo(deviceName, connectionId);
				console.log(`result: ${result}`);
			
				if (!mConnected) {
					mConnected = true;
					oGateServer.onConnected();
				}
				else {
					oGateServer.onReconnected();
				}
			}
			else {
				oGateServer.receive(cmd, data);
			}
		}
	}

	function onError(e)
	{
		console.log(`CGateServer onerror at ${new Date()}`);
	}

	function initWebsocket(wsUri)
	{
		const websocket = new WebSocket(wsUri);
		websocket.onopen = function (e) {
			onOpen(e, websocket);
		}
		websocket.onclose = function (e) {
			onClose(e);
		}
		websocket.onmessage = function (e) {
			onMessage(e);
		}
		websocket.onerror = function (e) {
			onError();
		}
	}

	CGateServer.prototype.start = function ({protocol, domain,ip, port})
	{
		// �O�s protocol
    	mProtocol = protocol;
		oGateServer = this;
		// call method in parent class
		CMiddleServer.prototype.start.call(this);
		if (protocol === 'https')
			mServerUri = `wss://${domain}:${port}/`;
		else
			mServerUri = `ws://${ip}:${port}/`;
		initWebsocket(mServerUri);
	}

	CGateServer.prototype.stop = function ()
	{
		// call method in parent class
		CMiddleServer.prototype.stop.call(this);

		// stop current connection.
		if (mWebsocket) {
			mWebsocket.onclose = null;
			mWebsocket.close();
			mWebsocket = null;
        }
		// clear server uri
		mServerUri = null;
		mConnected = false;
	}

	CGateServer.prototype.isConnected = function ()
	{
		return mWebsocket != null ? true : false;
	}

	CGateServer.prototype.send = function (cmd, data)
	{
		if (mWebsocket) {
			// build packet content
			const strCmd = JSON.stringify({
				cmd: cmd,
				data: data
			});
			mWebsocket.send(strCmd);
		}
	}

	CGateServer.prototype.reconnect = function ()
	{
		const serverUri = mServerUri;
		// call method in parent class
		CMiddleServer.prototype.reconnect.call(this);
		// stop current connection.
		if (mWebsocket) {
			mWebsocket.onclose = null;
			mWebsocket.close();
			mWebsocket = null;
        }
		// proceed reconnect
		initWebsocket(serverUri);
	}

	CGateServer.prototype.getProtocol = function () 
	{
    	return mProtocol;
	}
}

module.exports = CGateServer;